module.exports = __webpack_public_path__ + "img/mobileiot5.0d8a1461.png";